import { Container, Heading, Section } from 'react-bulma-components';

import React from 'react';

const Forbidden = () => {
  return (
    <Section>
      <Container>
        <p className="bd-notification is-danger">
          <Heading size={5} renderAs="p">You don't have access to this page</Heading>
        </p>
      </Container>
    </Section>
  );
}
export default Forbidden;
